import axios from 'axios';
import Config from './Config';
import UserManager from './User';
import { Keys, publish } from './MessageBus';

const instance = axios.create({
    baseURL: Config.BASE_URL,
});


function getCsrfToken() {
    // https://www.baeldung.com/spring-security-csrf
    const csrfToken = document.cookie.replace(/(?:(?:^|.*;\s*)XSRF-TOKEN\s*\=\s*([^;]*).*$)|^.*$/, '$1');
    return csrfToken;
}

function automaticallyParseDates(body: any) {
    // based on https://stackoverflow.com/a/66238542/1877617

    const propertiesToCheck = ['createdTime', 'updatedTime', 'startDate', 'endDate']

    function parseDate(datum: any) {
        if (!datum) {
            return;
        }
        for (let i = 0; i < propertiesToCheck.length; i++) {
            var prop = propertiesToCheck[i];
            if (datum.hasOwnProperty(prop) && datum[prop]) {
                datum[prop] = new Date(datum[prop]);
            }
        }
        if (typeof datum === 'object') {
            for (let key in datum) {
                if (datum.hasOwnProperty(key)) {
                    const value = datum[key];
                    if (Array.isArray(value)) {
                        for (let i = 0; i < value.length; i++) {
                            parseDate(value[i])
                        }
                    } else if (typeof datum === 'object') {
                        parseDate(value)
                    }
                }
            }
        }
    }

    if (body === null || body === undefined || typeof body !== "object")
        return body;

    if (Array.isArray(body)) {
        for (let i = 0; i < body.length; i++) {
            parseDate(body[i]);
        }
    } else {
        parseDate(body);
    }
}


instance.interceptors.request.use(function (config) {
    switch (config.method) {
        case 'post':
        case 'POST':
        case 'put':
        case 'PUT':
        case 'delete':
        case 'DELETE':
            config.headers['X-XSRF-TOKEN'] = getCsrfToken();
            break;
        default:
            break;
    }
    return config;
})

instance.interceptors.response.use(
    function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        automaticallyParseDates(response.data);
        return response;
    },
    function (error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        if (error && error.response && (401 === error.response.status || (error.response.status == 500 && error.response?.data.message && error.response.data.message == 'Cannot invoke "org.springframework.security.core.Authentication.getPrincipal()" because "authentication" is null'))) {
            // if (!window.location.hash.includes('/auth')) {
            //     setTimeout(() => {
            //         AppStore.logout();
            //         window.location.hash = '/';
            //     }, 0);
            // }
            publish(Keys.HTTP_UNAUTHORIZED_REQUEST, {
                response: error.response,
            });
        }
        if (error && error.response && 401 === error.response.status) {
            // https://gist.github.com/yajra/5f5551649b20c8f668aec48549ef5c1f
            publish(Keys.HTTP_UNAUTHORIZED_REQUEST, {
                response: error.response,
            });
        }
        return Promise.reject(error);
    }
);

if (Config.DEBUG) {
    window.Http = instance;
    window.http = instance;
}

export function getFileDownloadUrl(id) {
    return Config.BASE_URL + '/api/items/get-file/' + id + '?kw.authToken=' + UserManager.getAuthToken();
}

export default instance;
